import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import ProfileSelect from '../../../../containers/profiles/select/ProfileSelect'

const GeneralSection = () => {
  const form = useForm()
  const { handleChange } = useFormState()

  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" wrapOn="sm">
        <FormItem label="Nome*" field="label" />
      </Col>

      {!form.id && (
        <Col width="100%" wrapOn="sm">
          <FormItem label="Perfil base*" field="parent" Input={ProfileSelect} baseOnly />
        </Col>
      )}
    </Grid>
  )
}

export default GeneralSection
